import React, { Component, Fragment } from "react";
import client from "@culturehq/client";
import { Button, Loader, Success, Tooltip } from "@culturehq/components";

import { errorService, t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import SurveyItemResult from "./results/SurveyItemResult";

class SurveyResults extends Component {
  state = {
    loading: true,
    results: {},
    potentialRespondents: -1,
    error: null,
    exported: false
  };

  componentDidMount = async () => {
    const { survey: { id: surveyId } } = this.props;

    if (!surveyId) {
      return;
    }

    try {
      const { surveyResults, potentialRespondents } = await client.listSurveyResults({ surveyId });

      const results = {};
      surveyResults.forEach(result => {
        results[result.id] = result;
      });

      this.setState({ results, potentialRespondents, loading: false });
    } catch (error) {
      this.setState({ error, loading: false });
    }
  };

  handleExport = async () => {
    const { survey } = this.props;
    this.setState({ exported: true });

    try {
      await client.exportSurvey({ surveyId: survey.id });
    } catch (error) {
      errorService.error(error);
    }
  };

  render() {
    // Note: For events, it's possible to confirm "YES", then not take
    // the survey. For this reason, we need to use the total number of
    // rsvpBreakdown.attended instead of the survey response count.
    const { survey, overallResponseCount } = this.props;
    const { loading, results, potentialRespondents, error, exported } = this.state;

    const { surveyItems = [] } = survey;

    return (
      <Loader loading={loading}>
        {error && <ErrorMessage error={error} />}
        <div className="survey-export">
          {exported ? (
            <Success><Trans>Request received. An email will be sent to you soon.</Trans></Success>
          ) : (
            <Tooltip tip={t("Export the survey results. Once the list has been processed, an email will be sent to you with your data in a .csv file.")}>
              <Button primary onClick={this.handleExport} icon="ios-download-outline">
                <Trans>Export Data</Trans>
              </Button>
            </Tooltip>
          )}
        </div>
        <div className="survey-results">
          {surveyItems.map((surveyItem, index) => (
            <Fragment key={surveyItem.id}>
              <SurveyItemResult
                open
                itemNumber={index + 1}
                surveyItem={surveyItem}
                results={results[surveyItem.id] || {}}
                overallResponseCount={overallResponseCount || survey.responseCount}
                isRatingItem={surveyItem.id === survey.ratingItemId}
                potentialRespondents={potentialRespondents}
              />
              {index !== surveyItems.length - 1 && <hr />}
            </Fragment>
          ))}
        </div>
      </Loader>
    );
  }
}

export default SurveyResults;
